<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="医院名称">
        <el-input v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item>
      <el-form-item label="医院编码">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
          >{{ item.name }}</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <!-- <el-table-column type="selection" width="50">
      </el-table-column>-->
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="BWAcctNumber"
        label="医院编码(ZCN码)"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="医院名称"
        width=""
      ></el-table-column>
      <el-table-column
        prop="invoice_name"
        label="发票名称"
        width=""
      ></el-table-column>
      <el-table-column
        prop="Address"
        label="医院地址"
        width=""
        
      ></el-table-column>
      <el-table-column
        prop="cityid"
        label="城市"
        width=""
      ></el-table-column>
      <el-table-column
        prop="ProvinceID"
        label="省份"
        width=""
      ></el-table-column>
      <el-table-column
        prop="is_private"
        label="公私立"
        width=""
      ></el-table-column>
      <el-table-column
        prop="IsContainsEyes"
        label="执业范围是否包含眼科相关"
        width=""
      ></el-table-column>
      <el-table-column
        prop="sales_region_small"
        label="小区"
        width=""
      ></el-table-column>
      <el-table-column
        prop="sales_region_large"
        label="大区"
        width=""
      ></el-table-column>
      <el-table-column
        prop="Category"
        label="类型"
        width=""
      ></el-table-column>
      <el-table-column
        prop="level"
        label="级别"
        width=""
        
      ></el-table-column>
      <el-table-column
        prop="crystal_position_code"
        label="晶体销售岗位号"
        width="130"
        
      ></el-table-column>
      <el-table-column
        prop="crystal_sales_id"
        label="晶体销售"
        width=""
        
      ></el-table-column>
      <el-table-column
        prop="facility_position_code"
        label="设备销售岗位号"
          width="130"
      ></el-table-column>
      <el-table-column
        prop="facility_sales_id"
        label="设备销售"
        width=""
        
      ></el-table-column>
      <el-table-column
        prop="ref_crystal_position_code"
        label="REF销售岗位号"
        width="130"
        
      ></el-table-column>
      <el-table-column
        prop="ref_crystal_sales_id"
        label="REF销售"
        width=""
        
      ></el-table-column>
      <el-table-column
        prop="cat_crystal_position_code"
        label="Cat销售岗位号"
        width="120"
        
      ></el-table-column>
      <el-table-column
        prop="cat_crystal_sales_id"
        label="Cat销售"
        width=""
        
      ></el-table-column>
      <el-table-column
        prop="cat_Group"
        label="白内障私立医院集团"
        width="180"
        
      ></el-table-column>
      <el-table-column label="操作" width="120">
        <template scope="scope">
          <el-link type="primary" @click="handledetails(scope.row)">
            详情
          </el-link>
          |
          <el-link type="primary"   @click="handleEdit(scope.row)">编辑</el-link >
         <!-- <el-link type="info"> {{ scope.row.state == 1?'审批中': scope.row.state == 0?'审批通过':'已驳回' }} </el-link> -->
          <!-- <el-link
            type="primary"
            v-if="edit_if && scope.row.progress=='申请中'"
            @click="handleWithdraw(scope.row.id)"
          >
          |  撤回 </el-link
          > -->
         
          <!--<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination :background='true'
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  HcoQueryPage,
  store_data_ExportStore,
  store_data_Reback_Store,
  member_overrun_ExportExcel
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize:50
      },
      users: [],
      statusList: [
        { LinkUrl: "激活", value: true },
        { LinkUrl: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    };
  },
  methods: {
    ExportAccount() {
      // let para = this.filters
      var organization_id = localStorage.getItem("organization_id");
      let para = {
        organization_id:organization_id
      };
      //  para.account_manager = para.account_manager.toString()
      //  window.open("​/api​/store_data​/ExportStore?")
      member_overrun_ExportExcel(para).then((res) => {
        //window.open("http://47.103.87.196:8082" + res.data.msg);
        window.location.href = res.data.msg;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunc(item) {
      this[item.Func].apply(this, item);
    },
    // 导出
    // ExportAccount() {
    //   // let para = this.filters
    //   let para = {};
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   store_data_ExportStore(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    getModules_search() {
      this.page = 1;
      this.getModules();
    },
    //获取用户列表
    getModules() {
      let para = this.filters;
      para.page = this.page;
      console.log(para);
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true;
      HcoQueryPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel(ids) {
      console.log(ids);
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: ids };
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    handleWithdraw(id) {
      // 撤回
      store_data_Reback_Store("store_id=" + id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "撤回成功",
            type: "success",
          });
          this.getModules();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handledetails: function(e) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: "/HCO/HCO_details",
        query: {
          id: e.ID,
          approval_data_id: e.approval_data_id,
          type:'CK',
          back_url:'/HCO/HCO_list'
        },
      });
    },
    handleAdd() {
      this.$router.push({
        path: "/HCO/HCO_details",
        query: {
          type: "ADD",
          back_url:'/HCO/HCO_list'
        },
      });
    },
    
    //编辑
    handleEdit: function(ids, progress, outletnumber__c) {
      // console.log(id)
      // return
      this.$router.push({
        path: "/HCO/HCO_details",
        query: {
          id: ids,
          type: "EDIT",
          back_url:'/HCO/HCO_list'
        },
      });
    },
    handledetails_SalesOperation: function(ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: "/StoreManage/add_store",
        query: {
          id: ids,
          type: "store_ck",
          progress: progress,
          approval_type: "store",
          outletnumber__c: outletnumber__c,
          list_SalesOperation:1
        },
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //localStorage 存储数组对象的方法
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    },

    //localStorage 获取数组对象的方法
    getObjArr(name) {
      return JSON.parse(window.localStorage.getItem(name));
    },
    details_tag(name) {
      var router_list = this.getObjArr("router");
      for (let i in router_list) {
        for (let s in router_list[i].children) {
          //  console.log(999)
          if (router_list[i].children[s].id == "175") {
            //  console.log(999)
            router_list[i].children[s].name = name;
            router_list[i].children[s].meta.title = name;
            console.log(router_list[i].children[s].name);
            this.saveObjArr("router", router_list);
            console.log(this.getObjArr("router"));
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list);
    },
  },
  mounted() {
    console.log(this.getObjArr("router"));
    this.getModules();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
</style>
